import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import left from '../assets/left.png';

export default function BackButton({ title }) {
  const navigate = useNavigate();
  const location = useLocation();

const handleBack = () => {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate('/Portal/index.html');
  }
};


  return (
    <div className="back-button" onClick={handleBack}>
      <img src={left} alt="Back" />
      <h1 className="m-0">{title}</h1>
    </div>
  );
}


